import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useInspectionStore } from '@/context/inspectionStore';
import { VehiclePhotoSection } from './VehiclePhotoSection';

export function VehiclePhotoPage() {
  const navigate = useNavigate();
  const inspection = useInspectionStore(s => s.activeInspection);

  React.useEffect(() => {
    if (!inspection) navigate('/');
  }, [inspection, navigate]);

  if (!inspection) return null;

  return (
    <VehiclePhotoSection
      onComplete={() => navigate('/inspect')}
    />
  );
}